/* eslint-disable  */
import { getUnitConvertedUnit } from '@/Helpers';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import allProductServices from '@/Services/Form Services/allproduct.services';
import storeServices from '@/Services/Form Services/store.services';
import moment from 'moment';

export const tableApiConfig = {
	header: {
		storeList: {
			apiFunction: storeServices?.getStore,
			requestBuilder: () => ({
				id: '',
				type: 'RETAIL',
			}),
			responseTransform: (response, state) => {
				const storeList = response?.data?.filter(
					(store) => store?.parentStore === state?.fromStore
				);
				return {
					headers: [
						{
							name: 'S.No',
							id: 'S.No',
						},
						// Click a column name to sort by it (PoTableMultiple sorts store cells by qty).
						{
							name: 'Item Name',
							id: 'Item Name',
							sortable: true,
						},
						{
							name: 'SkuCode',
							id: 'SkuCode',
							sortable: true,
						},
						...[...storeList]
							?.slice()
							.sort(
								(a, b) =>
									(a.priority ?? 9999) - (b.priority ?? 9999)
							)
							.map((store) => ({
								name: `${store?.name} ${store?.shortName ? `(${store?.shortName})` : ''}`,
								storeName: store?.name,
								shortName: store?.shortName,
								priority: store?.priority,
								id: store?.id,
								sortable: true,
							})),
						{
							name: 'Total',
							id: 'Total',
						},
						{
							name: 'Actions',
							id: 'Actions',
						},
					],
					apiStoreList: storeList,
				};
			},
		},
		orderList: {
			apiFunction: inventoryAnalyticsServices?.fetchPoList,
			requestBuilder: (state) => ({
				req: {
					data: {
						filters: {
							fromStoreId: state?.fromStore ?? null,
							dateRangeFilter: {
								from: state?.expectedDeliveryDate
									? moment(
										state?.expectedDeliveryDate
									).format('YYYY-MM-DD')
									: null,
								to: state?.expectedDeliveryDate
									? moment(
										state?.expectedDeliveryDate
									).format('YYYY-MM-DD')
									: null,
								dateType: 'scheduled',
							},
							toProcessId: state?.internalProcess,
							shiftId: state?.internalShift,
							appOrderType: state?.orderType,
							orderType: 'sales/purchase',
							userOrderType: 'sales',
						},
					},
				},
			}),
			responseTransform: (response, state) => {
				const orderList = response?.data || [];
				return {
					headers: [
						{ name: 'S.No', id: 'S.No' },
						{ name: 'Item Name', id: 'Item Name', sortable: true },
						{ name: 'SkuCode', id: 'SkuCode', sortable: true },
						...orderList
							?.filter(
								(order) =>
									order?.orderStatus?.toLowerCase() !==
									'cancelled'
							)
							?.slice()
							?.map((order) => ({
								name: order?.storeName ?? order?.id,
								id: order?.id,
								orderId: order?.id,
								jsonData: order?.jsonData,
								priority: order?.jsonData?.priority,
								_storeId: order?.storeId,
								sortable: true,
							})),
						{ name: 'Total', id: 'Total' },
						{ name: 'Actions', id: 'Actions' },
					],
					apiStoreList: orderList, // Passing orders as "storeList" because multiplePoContent logic uses storeList.current
				};
			},
		},
	},
	row: {
		fetchItems: {
			apiFunction: inventoryAnalyticsServices?.fetchStandardPO,
			requestBuilder: (state, lists) => {
				return {
					params: {
						fromStore: state?.fromStore ?? null,
						orderType: state?.orderType ?? 'CMS',
						shiftName:
							(lists?.shiftList ?? [])?.find(
								(item) => item?.id === state?.internalShift
							)?.shiftName ?? null,
						orderDate: moment(state?.expectedDeliveryDate).format(
							'DD/MM/YYYY'
						),
					},
				};
			},
			responseTransform: (response, productList, stores) => {
				return response?.data?.map((item, index) => {
					return {
						Actions: { rowIndex: index },
						'S.No': index + 1,
						'Item Name':
							item?.productName + '(' + item?.variantName + ')',
						itemId: item?.variantId,
						SkuCode:
							productList
								?.flatMap((product) => product?.variants || [])
								?.find(
									(variant) => variant?.id == item?.variantId
								)?.clientVariantId ?? item?.clientVariantId,
						Total: '',
						...stores?.reduce((acc, store) => {
							acc[`${store?.id}`] = {
								qty: '',
								unit: getUnitConvertedUnit(
									null,
									item?.unit,
									true
								),
								storeId: store?.id,
								itemId: item?.variantId,
								productId: item?.productId,
							};
							return acc;
						}, {}),
					};
				});
			},
		},
		fetchPos: {
			apiFunction: inventoryAnalyticsServices?.fetchPoList,
			requestBuilder: (state) => {
				return {
					req: {
						data: {
							filters: {
								fromStoreId: state?.fromStore ?? null,
								dateRangeFilter: {
									from: state?.poCreationDate
										? moment(state?.poCreationDate).format(
											'YYYY-MM-DD'
										)
										: null,
									to: state?.poCreationDate
										? moment(state?.poCreationDate).format(
											'YYYY-MM-DD'
										)
										: null,
									dateType: 'scheduled',
								},
								toProcessId: state?.internalProcess,
								shiftId: state?.internalShift,
								appOrderType: state?.orderType,
								orderType: 'sales/purchase',
								userOrderType: 'sales',
							},
						},
					},
				};
			},
			responseTransform: (response, productList, stores) => {
				const groupedItems = {};
				response?.data?.forEach?.((list) => {
					list?.items?.forEach?.((item) => {
						const variantId = item?.variantId;

						if (!groupedItems[variantId]) {
							groupedItems[variantId] = {
								productName: item?.productName,
								variantName: item?.variantName,
								variantId: item?.variantId,
								productId: item?.productId,
								unit: item?.unit,
								clientVariantId: item?.clientVariantId,
								storeData: {},
							};
							// Initialize storeData for all stores
							stores?.forEach((store) => {
								groupedItems[variantId].storeData[store?.id] = {
									qty: '',
									orderedQty: 0,
									orderCount: 0,
									poIds: [],
									noOrder: true,
									unit: item?.unit,
									storeId: store?.id,
									itemId: item?.variantId,
									productId: item?.productId,
								};
							});
						}

						const storeId = list?.storeId;
						if (groupedItems[variantId].storeData[storeId]) {
							groupedItems[variantId].storeData[
								storeId
							].orderedQty += Number(item?.qty) || 0;
							groupedItems[variantId].storeData[
								storeId
							].orderCount += 1;
							groupedItems[variantId].storeData[
								storeId
							].noOrder = false;
							if (
								list?.id &&
								!groupedItems[variantId].storeData[
									storeId
								].poIds.includes(list?.id)
							) {
								groupedItems[variantId].storeData[
									storeId
								].poIds.push(list?.id);
							}
							if (item?.packaged) {
								const currentQty =
									groupedItems[variantId].storeData[storeId]
										.qty;
								groupedItems[variantId].storeData[storeId].qty =
									currentQty
										? Number(currentQty) +
										Number(item?.packaged)
										: item?.packaged;
							}
						}
					});
				});

				// Convert grouped items to array format
				return Object.values(groupedItems).map((item, index) => {
					return {
						Actions: { rowIndex: index },
						'S.No': index + 1,
						'Item Name':
							item?.productName + '(' + item?.variantName + ')',
						itemId: item?.variantId,
						SkuCode:
							productList
								?.flatMap((product) => product?.variants || [])
								?.find(
									(variant) => variant?.id == item?.variantId
								)?.clientVariantId ?? item?.clientVariantId,
						Total: '',
						...stores?.reduce((acc, store) => {
							acc[`${store?.id}`] = item.storeData[store?.id] || {
								qty: '',
								orderedQty: 0,
								orderCount: 0,
								poIds: [],
								noOrder: true,
								unit: item?.unit,
								storeId: store?.id,
								itemId: item?.variantId,
								productId: item?.productId,
							};
							return acc;
						}, {}),
					};
				});
			},
		},
		fetchOrderWiseItems: {
			apiFunction: inventoryAnalyticsServices?.fetchPoList,
			requestBuilder: (state) => ({
				req: {
					data: {
						filters: {
							fromStoreId: state?.fromStore ?? null,
							dateRangeFilter: {
								from: state?.expectedDeliveryDate
									? moment(
										state?.expectedDeliveryDate
									).format('YYYY-MM-DD')
									: null,
								to: state?.expectedDeliveryDate
									? moment(
										state?.expectedDeliveryDate
									).format('YYYY-MM-DD')
									: null,
								dateType: 'scheduled',
							},
							toProcessId: state?.internalProcess,
							shiftId: state?.internalShift,
							appOrderType: state?.orderType,
							orderType: 'sales/purchase',
							userOrderType: 'sales',
						},
					},
				},
			}),
			responseTransform: (response, productList, orders) => {
				const groupedItems = {};
				response?.data
					?.filter(
						(order) =>
							order?.orderStatus?.toLowerCase() !== 'cancelled'
					)
					?.forEach?.((order) => {
						const orderId = order?.id;
						order?.items?.forEach?.((item) => {
							const variantId = item?.variantId;

							if (!groupedItems[variantId]) {
								groupedItems[variantId] = {
									productName: item?.productName,
									variantName: item?.variantName,
									variantId: item?.variantId,
									productId: item?.productId,
									unit: item?.unit,
									clientVariantId: item?.clientVariantId,
									orderData: {},
								};
							}

							if (!groupedItems[variantId].orderData[orderId]) {
								groupedItems[variantId].orderData[orderId] = {
									qty: 0,
									unit: item?.unit,
									storeId: order?.storeId,
									itemId: item?.variantId,
									productId: item?.productId,
									orderId: order?.id,
								};
							}

							const currentQty =
								groupedItems[variantId].orderData[orderId]
									.qty || 0;
							groupedItems[variantId].orderData[orderId].qty =
								Number(currentQty) + (Number(item?.qty) || 0);
						});
					});

				return Object.values(groupedItems).map((item, index) => {
					return {
						Actions: { rowIndex: index },
						'S.No': index + 1,
						'Item Name':
							item?.productName + '(' + item?.variantName + ')',
						itemId: item?.variantId,
						SkuCode:
							productList
								?.flatMap((product) => product?.variants || [])
								?.find(
									(variant) => variant?.id == item?.variantId
								)?.clientVariantId ?? item?.clientVariantId,
						Total: '',
						...response?.data
							?.filter(
								(o) =>
									o?.orderStatus?.toLowerCase() !==
									'cancelled'
							)
							?.reduce((acc, order) => {
								acc[`${order?.id}`] = item.orderData[
									order?.id
								] || {
									qty: 0,
									unit: item?.unit,
									storeId: order?.storeId,
									itemId: item?.variantId,
									productId: item?.productId,
									orderId: order?.id,
								};
								return acc;
							}, {}),
					};
				});
			},
		},
	},
};
